import { createFileRoute } from "@tanstack/react-router";
import { QuestoveryPage } from "@/components/blocks/pages/QuestoveryPage";
import { getTranslator } from "@/lib/i18n";
import { resolveLocaleForPath } from "@/lib/i18n/locale";
import { buildSeo } from "@/lib/seo";

export const Route = createFileRoute("/{-$locale}/questovery")({
	component: QuestoveryPage,
	loader: ({ location, serverContext }) => ({
		locale: resolveLocaleForPath(location.pathname, serverContext),
	}),
	head: ({ loaderData }) => {
		if (!loaderData) return {};
		const t = getTranslator(loaderData.locale);
		return buildSeo({
			title: t((t) => t.seo.questoveryTitle),
			description: t((t) => t.seo.questoveryDescription),
			path: "/questovery",
			locale: loaderData.locale,
		});
	},
});
